// Det grafikkerne tegnes ud fra: kampdata, controllerens tilstand og tiden.

import { GFX_TIMERS, type GfxData, type GfxRound, type GfxState, type GfxTimer, type GfxTimerId } from "@mma/shared";

export interface GfxCtx {
  data: GfxData;
  state: GfxState;
  now: number; // servertid i ms
}

// Nedtælling vises rundet op: 5:00 indtil et helt sekund er gået, 0:00 ved
// slut. Over en time med timer foran, fx 1:05:00.
export function clock(sec: number, padMinutes = false): string {
  const s = Math.max(0, Math.ceil(sec - 1e-6));
  const pad = (n: number) => String(n).padStart(2, "0");
  if (s >= 3600) return `${Math.floor(s / 3600)}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
  const m = Math.floor(s / 60);
  return `${padMinutes ? pad(m) : m}:${pad(s % 60)}`;
}

// Et ur der aldrig er sat, står på sin standardlængde (rundeuret: kampens rundelængde).
export function timerState(ctx: GfxCtx, id: GfxTimerId): GfxTimer {
  const fallback = id === "round" ? (ctx.data.fight?.roundDurationSec ?? GFX_TIMERS.round) : GFX_TIMERS[id];
  return ctx.state.timers[id] ?? { durationSec: fallback, startedAt: null, elapsedSec: 0 };
}

export function timerRemaining(t: GfxTimer, now: number): number {
  if (t.targetAt != null) return Math.max(0, (t.targetAt - now) / 1000);
  const running = t.startedAt === null ? 0 : Math.max(0, (now - t.startedAt) / 1000);
  return Math.max(0, t.durationSec - t.elapsedSec - running);
}

export const timerRunning = (t: GfxTimer) => t.startedAt !== null || t.targetAt != null;

// Rundemarkøren gælder kun kampen den blev sat for; en ny kamp starter i runde 1.
export function roundOf(ctx: GfxCtx): GfxRound {
  const fightId = ctx.data.fight?.id ?? null;
  const r = ctx.state.round;
  if (r && r.fightId === fightId) return r;
  return { fightId, current: 1, total: Math.min(5, ctx.data.fight?.totalRounds ?? 3) };
}
